import React from "react";
import TableItem from "items/table/table";
import PaginatorContainer from "items/paginator/paginator-container";

const AdminMessages = (props) => {
    return (
        <div>
            <PaginatorContainer />
            <TableItem 
                        data={[props.tableHeader, props.data]} 
                        getValue={props.getValue}
                        height={415}
            />
        </div>
    )
}

export default AdminMessages;